<div
  class="monitor-layout bg-gradient"
  [class.sidebar-collapsed]="sidebarCollapsed()"
>
  <!-- Region 1: Sidebar -->
  <aside class="sidebar-container hv-shell-sidebar">
    <app-desktop-sidebar [(collapsed)]="sidebarCollapsed" />
  </aside>


  <!-- Region 3: Main Content -->
  <main class="main-content-container">
    <!-- Page Sub-Header (Sticky & Conditional) -->
    @if (pageContextService.subHeaderContent(); as content) {
    <div class="sub-header-wrapper">
      @if (isTemplateRef(content)) {
      <ng-container [ngTemplateOutlet]="content"></ng-container>
      } @else {
      <ng-container
        [ngComponentOutlet]="content.component"
        [ngComponentOutletInputs]="content.inputs"
      >
      </ng-container>
      }
    </div>
    }

    <!-- The actual page content -->
    <div class="page-body-container">
      <app-toast-stack />
      <router-outlet></router-outlet>
      @defer (when featureFlags.aiAssistantEnabled()) {
        <app-assistant-widget />
      }
    </div>
  </main>

  <!-- Region 4: Primary Aside -->
  @if (asideService.asideContext(); as context) {
  <aside
    animate.enter="hv-aside-enter"
    animate.leave="hv-aside-leave"
    class="aside-container pl-1"
    [style.width.px]="asideWidth()"
  >
    <div class="resize-handle" (mousedown)="onResizeStart($event)"></div>

    <!-- Aside Header -->
    <div
      class="flex-shrink-0 px-3 py-2.5 flex items-center justify-between gap-2 border-b border-border"
    >
      <app-text weight="semibold" class="truncate min-w-0">{{ context.title }}</app-text>
      <div class="flex items-center gap-1 shrink-0">
        @if (asideService.headerAction(); as action) {
          @if (action.label) {
            <app-button
              variant="ghost"
              size="xs"
              [icon]="action.icon"
              [title]="action.tooltip || action.label"
              [attr.aria-label]="action.tooltip || action.label"
              (click)="action.onClick()"
            >
              {{ action.label }}
            </app-button>
          } @else {
            <app-button
              variant="ghost"
              size="sm"
              [iconOnly]="true"
              [icon]="action.icon"
              shape="circle"
              [title]="action.tooltip || 'Open details'"
              [attr.aria-label]="action.tooltip || 'Open details'"
              (click)="action.onClick()"
            />
          }
        }
        <app-button
          variant="ghost"
          size="sm"
          [iconOnly]="true"
          icon="X"
          shape="circle"
          title="Close"
          aria-label="Close"
          (click)="asideService.close()"
        />
      </div>
    </div>

    <!-- Aside Body (Scrollable) -->
    <div class="flex-grow">
      <app-aside-content />
    </div>
  </aside>
  }
</div>
